import { Environments } from "../types/environment.type";


export const cmsURLS = {
  production: process.env.VIRTUAL_DOMAIN,
  preview: process.env.VIRTUAL_DOMAIN,
  localhost: "https://cms.uat.britishcarauctions.net",
};

const getCMSDomain = (environment: Environments): string => cmsURLS[environment];

export default getCMSDomain;
